"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bodyTypeSearch = void 0;
const types_1 = require("../../types");
const { BodyTypeEnum } = types_1.Vehicle;
exports.bodyTypeSearch = [
    {
        code: BodyTypeEnum.SUVCrossover,
        name: 'SUV/Crossover',
        value: ['SUV', 'Crossover'],
        is_searchable: true
    },
    {
        code: BodyTypeEnum.Pickup,
        name: 'Pickup/Truck',
        value: ['Pickup', 'Truck'],
        is_searchable: true,
        child: [
            {
                code: BodyTypeEnum.CrewCab,
                name: 'Crew Cab',
                value: ['Crew Cab'],
                doors: 4,
                is_searchable: true
            },
            {
                code: BodyTypeEnum.ExtendedCab,
                name: 'Extended Cab',
                value: ['Extended Cab'],
                is_searchable: true
            },
            {
                code: BodyTypeEnum.RegularCab,
                name: 'Regular Cab',
                value: ['Regular Cab'],
                doors: 2,
                is_searchable: true
            }
        ]
    },
    {
        code: BodyTypeEnum.Car,
        name: 'Car',
        value: ['Car'],
        is_searchable: true,
        child: [
            {
                code: BodyTypeEnum.SUVCrossover,
                name: 'Crossover',
                value: ['Crossover'],
                is_searchable: false
            },
            {
                code: BodyTypeEnum.Convertible,
                name: 'Convertible',
                value: ['Convertible'],
                is_searchable: false,
            },
            {
                code: BodyTypeEnum.Sedan,
                name: 'Sedan',
                value: ['Sedan'],
                doors: 4,
                is_searchable: true
            },
            {
                code: BodyTypeEnum.Coupe,
                name: 'Coupe',
                value: ['Coupe'],
                doors: 2,
                is_searchable: true
            },
            {
                code: BodyTypeEnum.Hatchback,
                name: 'Hatchback',
                value: ['Hatchback'],
                is_searchable: true
            },
            {
                code: BodyTypeEnum.Wagon,
                name: 'Wagon',
                value: ['Wagon'],
                is_searchable: true
            },
        ]
    },
    {
        code: BodyTypeEnum.Van,
        name: 'Van',
        value: ['Van'],
        is_searchable: true,
        child: [
            {
                code: BodyTypeEnum.MiniVan,
                name: 'Mini Van',
                value: ['Mini-Van'],
                is_searchable: true
            },
            {
                code: BodyTypeEnum.FullSizeVan,
                name: 'Full-Size Van',
                value: ['Full-Size'],
                is_searchable: true
            },
            {
                code: BodyTypeEnum.PassengerVan,
                name: 'Passenger Van',
                value: ['Extended Length Passenger'],
                is_searchable: true
            },
            {
                code: BodyTypeEnum.CargoVan,
                name: 'Cargo Van',
                value: ['Cargo', 'Extended Length Cargo'],
                is_searchable: true
            },
        ]
    },
    {
        code: BodyTypeEnum.Convertible,
        name: 'Convertible',
        value: ['Convertible'],
        is_searchable: true
    },
    {
        code: BodyTypeEnum.Chassis,
        name: 'Chassis',
        value: ['Chassis', 'Commercial/Cutaway/Chassis'],
        is_searchable: true
    },
    {
        code: BodyTypeEnum.SemiTrailerTruck,
        name: 'Semi-Trailer Truck',
        is_hd: true,
        value: ['Semi-Trailer Truck'],
        is_searchable: true
    },
    {
        code: BodyTypeEnum.Truck,
        name: 'Truck',
        is_hd: true,
        value: ['Truck'],
        is_searchable: false
    },
    {
        code: BodyTypeEnum.Bus,
        name: 'Bus',
        is_hd: true,
        value: ['Bus'],
        is_searchable: true
    }
];
